var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiSystemIds, ComponentIds, ProductUtils, VectorConstants, } from "@inter-ikea-core/core";
import { SystemBase4 } from "../systembase/SystemBase4";
/**
 * This system will listen to changes to @class {ProductParamsComponent} and scale any viewer object that
 * was found in a @class {ViewerObjectComponent} on the same entity.
 *
 * Note that the 3D models in the viewer are only scaled along each axis, nothing magic like cutting meshes
 * is going on. If a mesh needs cutting to look ok then contact viewer support for how to proceed.
 */
var ViewerObjectScalingSystem = /** @class */ (function (_super) {
    __extends(ViewerObjectScalingSystem, _super);
    function ViewerObjectScalingSystem(entityManager, logger) {
        if (logger === void 0) { logger = null; }
        var _this = _super.call(this, ComponentIds.PRODUCT_PARAMS_COMPONENT_ID, ComponentIds.VIEWER_OBJECT_COMPONENT_ID, ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID, ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID) || this;
        _this.id = "ViewerObjectScalingSystem";
        _this.systemsBeforeMe = [
            ApiSystemIds.PRODUCT_RESIZING_SYSTEM_ID,
        ];
        _this.systemsAfterMe = null;
        _this.doingChangesOnComponent = [];
        _this.logger = logger;
        _this.register(entityManager);
        _this.enable();
        return _this;
    }
    ViewerObjectScalingSystem.prototype.onAddComponent = function (entity, _newComponent) {
        this.scaleEntityInViewer(entity);
    };
    ViewerObjectScalingSystem.prototype.onUpdateComponent = function (entity, _oldComponent, _newComponent) {
        this.scaleEntityInViewer(entity);
    };
    ViewerObjectScalingSystem.prototype.onRemoveComponent = function (entity, _oldComponent) {
        this.scaleEntityInViewer(entity);
    };
    ViewerObjectScalingSystem.prototype.onAddComponent3 = function (entity, _newComponent) {
        if (!entity.hasComponent(ComponentIds.PRODUCT_PARAMS_COMPONENT_ID))
            return;
        var viewerObjectComponent = entity.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
        if (viewerObjectComponent) {
            this.onAddComponent2(entity, viewerObjectComponent);
        }
    };
    ViewerObjectScalingSystem.prototype.onUpdateComponent3 = function (entity, oldComponent, newComponent) {
        if (!entity.hasComponent(ComponentIds.PRODUCT_PARAMS_COMPONENT_ID))
            return;
        if (newComponent.hasFinishedLoading &&
            !oldComponent.hasFinishedLoading) {
            this.scaleEntityInViewer(entity);
        }
    };
    ViewerObjectScalingSystem.prototype.onRemoveComponent3 = function (_entity, _oldComponent) {
        // no need to act here, if we removed the visual representation, then we certainly don't need to scale it
    };
    ViewerObjectScalingSystem.prototype.onAddComponent2 = function (entity, _newComponent) {
        var _a;
        if (!((_a = entity.getComponent(ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.hasFinishedLoading))
            return;
        if (!entity.hasComponent(ComponentIds.PRODUCT_PARAMS_COMPONENT_ID))
            return;
        this.scaleEntityInViewer(entity);
    };
    ViewerObjectScalingSystem.prototype.onUpdateComponent2 = function (entity, _oldComponent, _newComponent) {
        if (!entity.hasComponent(ComponentIds.PRODUCT_PARAMS_COMPONENT_ID))
            return;
        this.scaleEntityInViewer(entity);
    };
    ViewerObjectScalingSystem.prototype.onRemoveComponent2 = function (_entity, _oldComponent) {
        // no need to act here, if we removed the visual representation, then we certainly don't need to scale it
    };
    ViewerObjectScalingSystem.prototype.onAddComponent4 = function (entity, _newComponent) {
        if (!entity.hasComponent(ComponentIds.PRODUCT_PARAMS_COMPONENT_ID))
            return;
        this.scaleEntityInViewer(entity);
    };
    /**
     * This will scale the 3d model in the viewer
     *
     * @param entity
     * @param newAbsoluteScale
     */
    ViewerObjectScalingSystem.prototype.scaleEntityInViewer = function (entity) {
        var _a, _b;
        var newAbsoluteScale = this.getProductScale(entity);
        (_b = (_a = entity
            .getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.viewerObject) === null || _b === void 0 ? void 0 : _b.setScale(newAbsoluteScale.X, newAbsoluteScale.Y, newAbsoluteScale.Z);
    };
    ViewerObjectScalingSystem.prototype.getProductScale = function (entity) {
        var _a, _b;
        var productScale = ProductUtils.getProductScale(entity);
        if (!productScale) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn(function () {
                return "ViewerObjectScalingSystem could not get scale from entity, will apply identity scale";
            });
            return VectorConstants.ONE;
        }
        if ([productScale.X, productScale.Y, productScale.Z].some(function (dimension) {
            return Number.isNaN(dimension);
        })) {
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.warn(function () {
                return "ViewerObjectScalingSystem got an invalid scale for entity, will apply identity scale";
            });
            return VectorConstants.ONE;
        }
        return productScale;
    };
    return ViewerObjectScalingSystem;
}(SystemBase4));
export { ViewerObjectScalingSystem };
//# sourceMappingURL=ViewerObjectScalingSystem.js.map